import React, { useState, useEffect } from 'react';
import API from 'utils/API';
import { Button, Card, CardBody, FormGroup, Label, Row, Col } from 'reactstrap';
import ReactStrapTable from 'components/reactStrapTable';
import { dateFormate, cellRendererCheck, fileFormatter } from 'utils/columns';
import CheckBoxCellRender from 'components/reactStrapTable/components/tableCellRender/CheckBoxCellRender';




let tableDataBackup=[];
const ProviderListTable = (props) => {
    const { data,SetProviderCount } = props;
    
    tableDataBackup = data;
    const [loading, setLoading] = useState(false);
    const [tableData, setTableData] = useState([]);


    useEffect(() => {
        setTableData(data);
        let count=0;
        tableDataBackup = data.map((row)=>{
            if(row.selcetedProvider=="Y"){
                count++;
            }
            return row;
        });        
        SetProviderCount(count);
      }, [data]);

    const updateRowValue = (value, col, rowData) => {
        let tempData = [...tableDataBackup];
        let count=0;
        tempData = tempData.map((row) => {
            if (row.providerId === rowData?.providerId) {
                row[col] = value;
            }
            if(row.selcetedProvider=="Y"){
                count++;
            }
            return row;
        });
        tableDataBackup = tempData;
        setTableData(tempData);
        SetProviderCount(count);
    };

    const cellCheckBoxRender = (row, columnName) => {
        return (
            <CheckBoxCellRender
                rowData={row}
                columnName={columnName.dataField}
                updateRowValue={updateRowValue}
            />
        );
    };




    const columns = [
        {
            dataField: 'selcetedProvider',
            text: '',
            cellRenderer: (rowData, col) => cellCheckBoxRender(rowData, col),
            width: 80,
        },
        {
            dataField: 'providerNPI',
            text: 'Provider NPI',
            width: 180,
        },
        {
            dataField: 'providerFirstName',
            text: 'Provider First Name',
            width: 180,
        },
        {
            dataField: 'providerLastName',
            text: 'Provider Last Name',
            width: 180,
        },
    ];

    return (
        <ReactStrapTable
            id='commnets'
            height={50 * tableData.length}
            columns={columns}
            data={tableData}
        />     
        
    );
};

export default ProviderListTable;
